import { DossierLightUpdateErrorInstance } from './planning-dossier-update-errors';

export interface PlanningPanelsStates {
  isLeftSideNavOpened: boolean | null;
  isRightSideNavOpened: boolean | null;
  isAppointmentFormOpened: boolean | null;
  isAppointmentFormReduced: boolean | null;
  isCustomEventFormOpened: boolean | null;
  formErrors: DossierLightUpdateErrorInstance[] | null;
  mustSaveToPrint: boolean | null;
}
